<template>
  <div class="section-wrapper">
    <div class="sede-section">
      <div class="section-content">
        <div class="row">
                    <div class="col-md-6">
            <!-- Title -->
            <h2 class="section-title mb-2">{{ config.sections.sede.title }}</h2>
            
            <!-- Subtitle -->
            <p class="section-subtitle mb-3">
              {{ config.sections.sede.subtitle }}
            </p>
            
            <!-- Loading State -->
            <div v-if="loading" class="loading-container">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
              <p class="mt-2">Cargando ubicaciones...</p>
            </div>
            
            <!-- Error State -->
            <div v-else-if="error" class="error-container">
              <div class="alert alert-danger">
                <strong>Error:</strong> {{ error }}
                <button class="btn btn-sm btn-outline-danger ml-2" @click="loadLocations">
                  Reintentar
                </button>
              </div>
            </div>
            
            <!-- Form Content -->
            <div v-else>
              <!-- Comuna Dropdown -->
              <div class="form-group mb-4">
                <label class="form-label mb-2">{{ config.sections.sede.fields.comuna.label }}</label>
                <select class="form-input" v-model="selectedComuna" @change="onComunaChange" :disabled="isPdvXProgram">
                  <option value="" disabled>Debe seleccionar una Comuna</option>
                  <option v-for="comuna in availableComunas" :key="comuna.id" :value="comuna.id">
                    {{ comuna.name }} ({{ comuna.regionName }})
                  </option>
                </select>
              </div>
              
              <!-- Listado de sedes Dropdown -->
              <div class="form-group mb-4">
                <label class="form-label mb-2">{{ config.sections.sede.fields.sedes.label }}</label>
                <select class="form-input" v-model="selectedSede" @change="onSedeChange" :disabled="!selectedComuna || isPdvXProgram">
                  <option value="" disabled>Debe seleccionar una Sede</option>
                  <option v-for="sede in availableSedes" :key="sede.id" :value="sede.id">
                    {{ removeWord(sede.name) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          
          <!-- Right Column - Map -->
          <div class="col-md-6">
            <div class="map-container">
                      <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14746.586520600613!2d-68.93621302848258!3d-22.479909736395246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96ac0835aed8e935%3A0xe17c2575c5851f04!2sAv.+Libertador+Bernardo+O&#39;Higgins%2C+Calama%2C+Regi%C3%B3n+de+Antofagasta%2C+Chile!5e0!3m2!1ses!2sco!4v1556506720077!5m2!1ses!2sco" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen></iframe> -->

                      <!-- src="https://maps.google.com/maps?q=Heroes%20de%20la%20Concepci%C3%B3n%20%232555%2C%20Iquique%2C%20Chile&t=&z=15&ie=UTF8&iwloc=&output=embed"  -->

                      <!-- :src="getGmapsEmbedURL"  -->
                      <div class="mapouter">
                        <div class="gmap_canvas">
                          <iframe
                            v-if="gmapsEmbedURL"
                            width="100%"
                            height="280"
                            id="gmap_canvas"
                            :src="gmapsEmbedURL"
                            frameborder="0"
                            scrolling="no"
                            marginheight="0"
                            marginwidth="0"
                          >
                          </iframe>
                        </div>
                      </div>
                      <!-- process.env.VUE_APP_GMAPS_KEY -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { locationsService, programsService } from '@/services'
import { mapActions } from 'vuex'
import ignoredVenues from '@/constants/ignoredVenues.json'

export default {
  name: 'SedeSelector',
  props: {
    programa: { type: String, default: 'Presencial' },
    year: { type: [String, Number], default: '4' },
    modalidad: { type: String, default: null },
    preferredLocation: { type: Object, default: null },
    programData: { type: Object, default: null },
    stepperData: { type: Object, default: null },
    savedComuna: { type: [String, Number], default: null },
    savedSede: { type: [String, Number], default: null }
  },
  data() {
    return {
      selectedComuna: "",
      selectedSede: "",
      locationsData: [],
      allLocationsData: [],
      availableComunas: [],
      availableSedes: [],
      loading: true,
      error: null,
      gmapsEmbedURL: null,
      initialized: false,
      config: {
        sections: {
          sede: {
            title: "Sede",
            subtitle: "Selecciona una región y la sede en donde quieres estudiar",
            fields: {
              comuna: { label: "Comuna" },
              sedes: { label: "Listado de sedes" }
            }
          }
        }
      }
    }
  },
  computed: {
    isPdvXProgram() {
      const programaLower = this.programa ? this.programa.toLowerCase() : '';
      const modalidadLower = this.modalidad ? this.modalidad.toLowerCase() : '';
      
      const isPdvX = programaLower.includes('pdvx') || 
                    programaLower.includes('pdv online') ||
                    modalidadLower.includes('pdvx') || 
                    modalidadLower.includes('pdv online');
      return isPdvX;
    },
    selectedComunaName() {
      if (!this.selectedComuna) return null
      const comuna = this.availableComunas.find(c => c.id === this.selectedComuna)
      return comuna ? `${comuna.name} (${comuna.regionName})` : null
    },
    selectedSedeName() {
      if (!this.selectedSede) return null
      const sede = this.availableSedes.find(s => s.id === this.selectedSede)
      return sede ? sede.name : null
    },
    currentSedeInfo() {
      if (!this.selectedSede || this.selectedSede === "") {
        return { address: null, shortName: null, subtitle: null }
      }
      const sede = this.availableSedes.find(s => s.id === this.selectedSede)
      if (!sede) {
        return { address: null, shortName: null, subtitle: null }
      }
      return {
        address: sede.address || 'Dirección no disponible',
        shortName: sede.name.replace('Preuniversitario ', ''),
        subtitle: sede.name.includes('Preuniversitario') ? 'Preuniversitario' : 'Centro de Estudios'
      }
    }
  },
      async mounted() {
      await this.loadLocations()
      this.$nextTick(() => {
        
        if (this.isPdvXProgram) {
          this.loadPdvXVirtualSede()
        } else if (this.preferredLocation) {
          this.loadPreferredLocation()
        } else if (this.savedComuna && this.savedSede) {
          this.loadSavedSelections()
        }
      })
    },
  watch: {
    programa(newPrograma, oldPrograma) {
      const wasPdvX = oldPrograma && oldPrograma.toLowerCase().includes('pdvx')
      const isPdvX = newPrograma && newPrograma.toLowerCase().includes('pdvx')
      // Solo cargar si cambia el tipo de programa (PDVx vs normal) o si es la primera vez
      if ((wasPdvX !== isPdvX || newPrograma) && !this.initialized) {
        this.initialized = true;
        this.loadLocations().then(() => {
          if (isPdvX) {
            this.loadPdvXVirtualSede()
          } else if (this.preferredLocation) {
            this.loadPreferredLocation()
          }
        })
      }
    },
    year(newYear) {
      // Solo cargar una vez al inicializar
      if (newYear && !this.initialized) {
        this.initialized = true;
        this.loadLocations().then(() => {
          if (this.isPdvXProgram) {
            this.loadPdvXVirtualSede()
          } else if (this.preferredLocation) {
            this.loadPreferredLocation()
          }
        })
      }
    },
    programData(newProgramData) {
      // Solo cargar una vez al inicializar
      if (newProgramData && !this.initialized) {
        this.initialized = true;
        this.loadLocations().then(() => {
          if (this.isPdvXProgram) {
            this.loadPdvXVirtualSede()
          } else if (this.preferredLocation) {
            this.loadPreferredLocation()
          } else {
            this.syncSavedSelections()
          }
        })
      }
    },
    stepperData(newStepperData) {
      // Solo sincronizar una vez al cargar inicialmente
      if (newStepperData && !this.loading && !this.initialized) {
        this.initialized = true;
        // Solo sincronizar si NO es un programa PDVx
        if (!this.isPdvXProgram) {
          this.syncSavedSelections()
        }
      }
    },
    savedComuna(newComuna) {
      if (newComuna && !this.loading && !this.preferredLocation) {
        this.loadSavedSelections()
      }
    },
    savedSede(newSede) {
      if (newSede && !this.loading && !this.preferredLocation) {
        this.loadSavedSelections()
      }
    },
    availableSedes(newSedes) {
      // Cuando cambien las sedes disponibles, verificar si necesitamos seleccionar la virtual
      if (this.isPdvXProgram && newSedes.length > 0) {
        const virtualSede = newSedes.find(s => s.id === 42 || s.id === '42')
        if (virtualSede && !this.selectedSede) {
          this.selectedSede = virtualSede.id
          this.saveSelectedSede(virtualSede)
          this.updateGmapsEmbedURL()
        }
      }
    }
  },
  methods: {
    ...mapActions(['saveSelectedComuna', 'saveSelectedSede']),

    // Método helper para construir preferredLocation con estructura completa
    buildPreferredLocation(sede) {
      return {
        communeId: this.selectedComuna,
        id: this.selectedSede,
        name: this.selectedSedeName,
        address: sede?.address || '',
        City: {
          name: sede?.City?.name || sede?.Commune?.name || ''
        },
        Commune: {
          name: sede?.Commune?.name || ''
        }
      }
    },

    async loadLocations() {
      this.loading = true
      this.error = null
      try {
        const isPdvX = this.isPdvXProgram

        this.allLocationsData = isPdvX
          ? await locationsService.getPdvXLocations()
          : await locationsService.getLocations()
        this.availableComunas = locationsService.getUniqueComunas(this.allLocationsData)

        if (this.programData?.Locations) {
          this.locationsData = [this.programData]
        } else if (this.modalidad) {
          this.locationsData = await programsService.getComunasByProgram(this.modalidad, this.year)
        }

        if (isPdvX) {
          // Para programas PDVx, ignorar preferredLocation y cargar sede virtual
          this.$nextTick(() => {
            this.loadPdvXVirtualSede()
          })
        } else if (this.preferredLocation) {
          this.loadPreferredLocation()
        } else {
          this.syncSavedSelections()
        }
      } catch (error) {
        console.error('Error al cargar ubicaciones:', error)
        this.error = 'No se pudieron cargar las ubicaciones del programa. Por favor, intenta nuevamente.'
      } finally {
        this.loading = false
      }
    },

    loadPdvXVirtualSede() {
      // Buscar la sede virtual por múltiples criterios
      const virtualSede = this.allLocationsData.find(loc => {
         if (loc.id === 42 || loc.id === '42') {
           return true
         }
         return false
       })
       
       if (virtualSede && virtualSede.Commune) {
         // Forzar la actualización de la comuna
         this.selectedComuna = virtualSede.Commune.id
         this.saveSelectedComuna(virtualSede.Commune)
         
         // Obtener las sedes disponibles para esta comuna
         this.availableSedes = this.getSedesForComuna(this.selectedComuna)
         
         // Buscar la sede en la lista disponible
         const sedeInList = this.availableSedes.find(s => s.id === virtualSede.id)
         
         if (sedeInList) {
           // Forzar la actualización de la sede
           this.selectedSede = sedeInList.id
           this.saveSelectedSede(sedeInList)
           this.updateGmapsEmbedURL()
           
                       // Construir preferredLocation con estructura completa
           const preferredLocation = this.buildPreferredLocation(sedeInList)
           
           // Emitir eventos para notificar los cambios
            this.$emit('comuna-changed', {
              comunaId: this.selectedComuna,
              comunaName: this.selectedComunaName
            })
            this.$emit('sede-selected', {
              comunaId: this.selectedComuna,
              comunaName: this.selectedComunaName,
              sedeId: this.selectedSede,
              sedeName: this.selectedSedeName,
              sedeInfo: this.currentSedeInfo,
              preferredLocation: preferredLocation
            })
            
            // Emitir evento para actualizar el stepperData.step3 con la sede virtual
            this.$emit('update-stepper-data', {
              step: 3,
              data: {
                selectedComuna: this.selectedComuna,
                selectedSede: this.selectedSede,
                selectedComunaName: this.selectedComunaName,
                selectedSedeName: this.selectedSedeName,
                sedeInfo: this.currentSedeInfo
              }
            })

           
                       // Forzar la actualización del DOM
            this.$nextTick(() => {
              // Verificar que los selects se actualizaron correctamente
              if (this.selectedComuna && this.selectedSede) {
                // Forzar la actualización de los selects
                this.forceUpdateSelects()
              }
            })
         } else {
           console.warn('❌ Sede virtual no encontrada en la lista de sedes disponibles')
           this.syncSavedSelections()
         }
       } else {
         console.warn('❌ No se encontró sede virtual con ID 42')
         this.syncSavedSelections()
       }
     },

    removeWord(word) {
      return word.replace('Preuniversitario ', '').replace('Pre Norte ', '').replace('Pre Sede ', '')
    },

    updateGmapsEmbedURL() {
      if (!this.selectedSede || this.selectedSede === "") {
        this.gmapsEmbedURL = null
        return
      }
      
      const sede = this.availableSedes.find(s => s.id === this.selectedSede)
      
      if (!sede || !sede.address) {
        this.gmapsEmbedURL = null
        return
      }

      const comuna = this.availableComunas.find(c => c.id === this.selectedComuna)
      const comunaName = comuna ? comuna.name : ''
      
      // Para la sede virtual, usar la dirección específica
      let queryString
      if (sede.address.toLowerCase().includes('apoquindo 5142') || 
          sede.name.toLowerCase().includes('virtual') ||
          sede.id === 42) {
        queryString = 'Avda. Apoquindo 5142, Las Condes, Chile'
      } else {
        queryString = `${sede.address.split(",")[0]},${comunaName},Chile`
      }
      
      this.gmapsEmbedURL = `https://maps.google.com/maps?q=${encodeURIComponent(queryString)}&t=&z=15&ie=UTF8&iwloc=&output=embed`
    },

    loadPreferredLocation() {
      const comuna = this.availableComunas.find(c => c.id === this.preferredLocation.communeId)
      if (comuna) {
        this.selectedComuna = comuna.id
        this.availableSedes = this.getSedesForComuna(this.selectedComuna)
        const sede = this.availableSedes.find(s => s.id === this.preferredLocation.id)
        if (sede) {
          this.selectedSede = sede.id
          this.updateGmapsEmbedURL()
          this.$emit('comuna-changed', {
            comunaId: this.selectedComuna,
            comunaName: this.selectedComunaName
          })
          
          // Construir preferredLocation con estructura completa
          const preferredLocation = this.buildPreferredLocation(sede)
          
          this.$emit('sede-selected', {
            comunaId: this.selectedComuna,
            comunaName: this.selectedComunaName,
            sedeId: this.selectedSede,
            sedeName: this.selectedSedeName,
            sedeInfo: this.currentSedeInfo,
            preferredLocation: preferredLocation
          })
        } else {
          this.syncSavedSelections()
        }
      } else {
        this.syncSavedSelections()
      }
    },

    onComunaChange() {
      this.selectedSede = ""
      this.gmapsEmbedURL = null // Limpiar el mapa cuando se cambia la comuna
      this.availableSedes = this.getSedesForComuna(this.selectedComuna)
      const comuna = this.availableComunas.find(c => c.id === this.selectedComuna)
      if (comuna) this.saveSelectedComuna(comuna)
      this.$emit('comuna-changed', {
        comunaId: this.selectedComuna,
        comunaName: this.selectedComunaName
      })
    },

    getSedesForComuna(comunaId) {
      const excludedNames = new Set(ignoredVenues);
      const sedes = this.allLocationsData
        .filter(loc => {
          // Verificar si tiene Commune y coincide con el ID
          const hasCommune = loc.Commune && loc.Commune.id === comunaId
          // También verificar si tiene communeId directo
          const hasCommuneId = loc.communeId === comunaId
          
          return hasCommune || hasCommuneId
        })
        .map(loc => ({ 
          id: loc.id, 
          name: loc.name, 
          address: loc.address, 
          phone: loc.phone,
          pdvId: loc.pdvId,
          commerceCode: loc.commerceCode,
          City: loc.City || null,
          Commune: loc.Commune || null
        }))
        .filter(s => {
          // Normalizar nombre para comparar contra la lista excluida
          const normalized = s.name
            .replace(/^\s*Preuniversitario\s*/i, '')
            .replace(/^\s*Pre Sede\s*/i, '')
            .replace(/^\s*Pre Norte\s*/i, '')
            .trim();
          // Excluir sedes de la lista ignorada y también "Alameda"
          return !excludedNames.has(normalized) && !normalized.toLowerCase().includes('alameda');
        })
        .sort((a, b) => a.name.localeCompare(b.name))
      
      return sedes
    },

    onSedeChange() {
      const sede = this.availableSedes.find(s => s.id === this.selectedSede)
      if (sede) this.saveSelectedSede(sede)
      this.updateGmapsEmbedURL()
      
      // Construir preferredLocation con estructura completa
      const preferredLocation = this.buildPreferredLocation(sede)
      
      this.$emit('sede-selected', {
        comunaId: this.selectedComuna,
        comunaName: this.selectedComunaName,
        sedeId: this.selectedSede,
        sedeName: this.selectedSedeName,
        sedeInfo: this.currentSedeInfo,
        preferredLocation: preferredLocation
      })
    },

    syncSavedSelections() {
      // No sincronizar si es un programa PDVx
      if (this.isPdvXProgram) {
        return;
      }
      
      const step3 = this.stepperData?.step3
      if (step3 && this.availableComunas.length) {
        const comuna = this.availableComunas.find(c => c.id === step3.selectedComuna)
        if (comuna) {
          this.selectedComuna = comuna.id
          this.availableSedes = this.getSedesForComuna(this.selectedComuna)
          const sede = this.availableSedes.find(s => s.id === step3.selectedSede)
          if (sede) {
            this.selectedSede = sede.id
            this.updateGmapsEmbedURL()
            this.$emit('comuna-changed', {
              comunaId: this.selectedComuna,
              comunaName: this.selectedComunaName
            })
            
            // Construir preferredLocation con estructura completa
            const preferredLocation = this.buildPreferredLocation(sede)
            
            this.$emit('sede-selected', {
              comunaId: this.selectedComuna,
              comunaName: this.selectedComunaName,
              sedeId: this.selectedSede,
              sedeName: this.selectedSedeName,
              sedeInfo: this.currentSedeInfo,
              preferredLocation: preferredLocation
            })
          }
        }
      }
    },

    loadSavedSelections() {
      const comuna = this.availableComunas.find(c => c.id === this.savedComuna)
      if (comuna) {
        this.selectedComuna = comuna.id
        this.availableSedes = this.getSedesForComuna(this.selectedComuna)
        const sede = this.availableSedes.find(s => s.id === this.savedSede)
        if (sede) {
          this.selectedSede = sede.id
          this.updateGmapsEmbedURL()
          this.$emit('comuna-changed', {
            comunaId: this.selectedComuna,
            comunaName: this.selectedComunaName
          })
          
          // Construir preferredLocation con estructura completa
          const preferredLocation = this.buildPreferredLocation(sede)
          
          this.$emit('sede-selected', {
            comunaId: this.selectedComuna,
            comunaName: this.selectedComunaName,
            sedeId: this.selectedSede,
            sedeName: this.selectedSedeName,
            sedeInfo: this.currentSedeInfo,
            preferredLocation: preferredLocation
          })
        }
      }
    },
    
    forceUpdateSelects() {
      // Forzar la actualización de los selects
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_inputs-shared.scss';
/* Estilos existentes del componente */
.loading-container {
  text-align: center;
  padding: 40px 0;
}

.error-container {
  margin-bottom: 20px;
}

.map-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  background-color: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
}

.placeholder-icon {
  margin-bottom: 16px;
}

.placeholder-text {
  color: #6c757d;
  font-size: 14px;
  text-align: center;
  margin: 0;
}

.section-wrapper {
  margin-bottom: 2rem;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

.section-subtitle {
  color: #666;
  font-size: 0.95rem;
}

.map-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.map-content {
  position: relative;
  height: 300px;
  background: #f8f9fa;
}

.location-pin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.pin-label {
  margin-top: 8px;
  font-size: 12px;
  color: #333;
}

.map-controls {
  position: absolute;
  right: 16px;
  top: 16px;
}

.zoom-btn {
  display: block;
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}

.google-logo {
  position: absolute;
  bottom: 8px;
  left: 8px;
}

.google-text {
  font-size: 10px;
  color: #666;
  font-weight: 500;
}

/* Form and Section Styles */
.sede-section {
  background: white;
  border-radius: 8px;
  padding: 24px;
}

.section-content {
  width: 100%;
}

/* Form styles */
.form-group {
  margin-bottom: 1rem;
}

.form-label {
  font-family: "Poppins-Medium";
  font-weight: 100;
  color: #333;
  margin-bottom: 0.5rem;
}

/* Estilos de selects manejados por _inputs-shared.scss */

/* Estilos para alineación del mapa con el título */
.sede-section .row {
  align-items: flex-start;
  display: flex;
}

.sede-section .col-md-6 {
  display: flex;
  flex-direction: column;
}

/* Responsive styles */
@media (max-width: 768px) {
  .sede-section .row {
    flex-direction: column;
  }
  
  .sede-section .col-md-6 {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style> 
